var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXSymbol(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.575 5.7a1.5 1.5 0 10-1.8-2.4c-2.471 1.853-4.95 3.88-7.31 6.014l-4.277-3.92a1.5 1.5 0 10-2.027 2.212l4.106 3.762c-2.59 2.504-4.974 5.12-6.964 7.755a1.5 1.5 0 002.394 1.808c1.918-2.539 4.242-5.084 6.786-7.532l5.678 5.207a1.5 1.5 0 102.028-2.211l-5.502-5.045a101.119 101.119 0 016.888-5.65z",
    fill: "#121318"
  })));
}

export default SvgXSymbol;